import { render, staticRenderFns } from "./AddTransferC.vue?vue&type=template&id=12521d7c&scoped=true"
import script from "./AddTransferC.vue?vue&type=script&lang=js"
export * from "./AddTransferC.vue?vue&type=script&lang=js"
import style0 from "./AddTransferC.vue?vue&type=style&index=0&id=12521d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12521d7c",
  null
  
)

export default component.exports